import { Component } from '@angular/core';

@Component({
  selector: 'fin-header-without-navigation',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header-without-navigation.component.html',
})
export class HeaderWithoutNavigationComponent {}
